export const BRAND = {
  name: "LifeButton.org",
  tagline: "We Are Here To Help",
  phone: "(888) 777-1644",
  phoneHref: "tel:8887771644",
  email: "info@lifebutton.org",
  rating: "4.9",
  familiesServed: "12,400+",
};

export const IMAGES = {
  logoLight:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_a8cb003c-b1ea-4005-a8e9-1f1b13340cb6/artifacts/okrkzae2_PHOTO-2026-08-05-15-16-37.jpg",
  logoDark:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_a8cb003c-b1ea-4005-a8e9-1f1b13340cb6/artifacts/3dcs29wv_PHOTO-2026-08-05-15-17-01.jpg",
  heroSenior:
    "https://images.unsplash.com/photo-1625690988276-0a7b0cdf3d5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxlbGRlcmx5JTIwY291cGxlJTIwaGFwcHl8ZW58MHx8fHwxNzg1OTU4MjIxfDA&ixlib=rb-4.1.0&q=85",
  couple:
    "https://images.unsplash.com/photo-1758691031787-90867cb6fb2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGVsZGVybHklMjBjb3VwbGUlMjBhdCUyMGhvbWV8ZW58MHx8fHwxNzgyODUxNjkxfDA&ixlib=rb-4.1.0&q=85",
  caregiver:
    "https://images.unsplash.com/photo-1646663133945-db03f563076a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBodWdnaW5nJTIwc2VuaW9yfGVufDB8fHx8MTc4NTk1ODIwNnww&ixlib=rb-4.1.0&q=85",
  operator:
    "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxjYWxsJTIwY2VudGVyJTIwb3BlcmF0b3IlMjBoZWFkc2V0fGVufDB8fHx8MTc4NTk1ODIwNnww&ixlib=rb-4.1.0&q=85",
  hands:
    "https://images.unsplash.com/photo-1589061434060-a05a5335bfbb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjYXJlZ2l2ZXIlMjBob2xkaW5nJTIwaGFuZHMlMjB3aXRoJTIwc2VuaW9yfGVufDB8fHx8MTc4NTk1OTAzN3ww&ixlib=rb-4.1.0&q=85",
};

export const TRUST_BADGES = [
  "UL-LISTED DEVICES",
  "24/7 US-BASED MONITORING",
  "NO LONG-TERM CONTRACT",
  "TMA FIVE DIAMOND CERTIFIED",
  "FREE US SHIPPING",
  "AUTOMATIC FALL DETECTION",
  "CANCEL ANY TIME",
];

export const STATS = [
  { value: "12,400+", label: "Families protected" },
  { value: "< 15 sec", label: "Average response time" },
  { value: "4.9 / 5", label: "Customer rating" },
  { value: "24/7/365", label: "US-based monitoring" },
];

// Numbered manifesto — "Three things every other provider gets wrong"
export const MANIFESTO = [
  {
    n: "01",
    icon: "ShieldAlert",
    title: "Real automatic fall detection",
    body: "A combined accelerometer, gyroscope and barometric sensor detects a genuine fall. If you don't cancel the alert, our operators are called automatically — even if you can't press the button.",
  },
  {
    n: "02",
    icon: "Headset",
    title: "US-based operators, in seconds",
    body: "TMA Five Diamond Certified specialists answer every call — average response under 15 seconds. No offshore call centers, no menus, no robots. Just a calm human who can see your address.",
  },
  {
    n: "03",
    icon: "FileX",
    title: "No long-term contract",
    body: "Month-to-month service you can cancel any time, for any reason. No fees, no penalties, no equipment held hostage. We earn your trust every single month.",
  },
];

export const STEPS = [
  {
    n: "1",
    icon: "MousePointerClick",
    title: "Choose your device",
    body: "Take our 60-second match or call a specialist. In-home, mobile GPS, fall detection or smartwatch — we help you pick the right fit.",
  },
  {
    n: "2",
    icon: "PackageCheck",
    title: "We ship & activate it free",
    body: "Your device arrives ready to go — pre-charged and pre-activated on the cellular network. No Wi-Fi, no setup, no technician needed.",
  },
  {
    n: "3",
    icon: "BellRing",
    title: "Press the button, we answer",
    body: "One press connects you to a live US operator who confirms your location, talks you through it, and dispatches help while staying on the line.",
  },
];

export const PLANS = [
  {
    name: "Basic",
    price: 29.95,
    tagline: "Essential in-home protection",
    features: [
      "24/7 US-based monitoring",
      "In-home base + help button",
      "Two-way voice",
      "Free equipment",
      "Cancel any time",
    ],
    popular: false,
  },
  {
    name: "Preferred",
    price: 34.95,
    tagline: "Protection on the go",
    features: [
      "Everything in Basic",
      "Mobile GPS device",
      "Nationwide 4G LTE coverage",
      "Location sharing",
      "Free US shipping",
    ],
    popular: true,
  },
  {
    name: "Premium",
    price: 44.95,
    tagline: "Complete peace of mind",
    features: [
      "Everything in Preferred",
      "Automatic fall detection",
      "Caregiver mobile app",
      "Daily wellness check-ins",
      "Priority dispatch",
    ],
    popular: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "My mother slipped in the kitchen and with one press of the button, help arrived in minutes. It gives me peace of mind knowing she's protected 24/7.",
    name: "Karen M.",
    location: "Tampa, FL",
    context: "Mother lives alone",
  },
  {
    quote:
      "The fall detection caught it before she'd even processed she was on the floor. The operator was talking to her in under fifteen seconds and stayed until the paramedics arrived.",
    name: "David R.",
    location: "Columbus, OH",
    context: "Mother fell in the bathroom",
  },
  {
    quote:
      "I'm eighty-one and I forget to charge things. The device goes a month between charges — that's the only reason I actually wear it. A real person picks up every time in seconds.",
    name: "Eleanor P.",
    location: "Boise, ID",
    context: "Type-2 diabetic, lives alone",
  },
  {
    quote:
      "The smartwatch looks like a watch. Dad wears watches. End of negotiation. Six months in he's pressed it twice — both real, both handled in under a minute.",
    name: "Michael T.",
    location: "Portland, ME",
    context: "Father refused a pendant",
  },
  {
    quote:
      "I twisted an ankle forty minutes from cell coverage. The device had bars when my phone didn't. The operator pulled my coordinates and stayed on the line while I limped to a clearing.",
    name: "Robert K.",
    location: "Bozeman, MT",
    context: "Hikes rural roads alone",
  },
  {
    quote:
      "I live 900 miles away. The caregiver app shows me Mom's device is charged and she's home. When she pressed it by accident, they called her, then called me to say she was fine.",
    name: "Jennifer L.",
    location: "Madison, WI",
    context: "Mother lives out of state",
  },
];

export const FAQS = [
  {
    q: "How much does it cost?",
    a: "Monitoring plans start at $29.95/mo for in-home protection. Devices are a one-time purchase and shipping is always free. There are no activation fees and no long-term contracts — you can cancel any time.",
  },
  {
    q: "Does it work outside the home?",
    a: "Yes. Our GoMobile GPS, FallGuard Pro and LifeWatch Smart devices use nationwide 4G LTE with built-in GPS, so help follows you wherever you go — on a walk, in the car, or on vacation.",
  },
  {
    q: "How accurate is fall detection?",
    a: "FallGuard Pro combines an accelerometer, gyroscope and barometric sensor to detect genuine falls. If a fall is detected and you don't cancel the alert, our monitoring center is contacted automatically. No system is 100% accurate, so we always recommend pressing the button when you can.",
  },
  {
    q: "What happens when I press the button?",
    a: "You're connected to a live, US-based TMA Five Diamond Certified operator — on average in under 15 seconds. They can see your address, talk you through the situation, contact your family or emergency services, and stay on the line until help arrives.",
  },
  {
    q: "Will it work in the shower?",
    a: "Yes. Our help buttons and FallGuard Pro pendant are fully waterproof, so you can wear them in the shower and bath — statistically where many falls happen.",
  },
  {
    q: "Do I need Wi-Fi or a landline?",
    a: "No. Our mobile and fall-detection devices arrive pre-activated on the cellular network — no Wi-Fi password, no landline, and no technician required. Just take it out of the box and wear it.",
  },
];

export const NAV_LINKS = [
  { label: "Devices", to: "/shop" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Pricing", to: "/pricing" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQ", to: "/faq" },
  { label: "About", to: "/about" },
];
